import { createClient } from 'contentful-management';
import { curry, omit, pluck, reject, contains, map, path, __ } from 'ramda';
import { useState, createElement, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ValidationMessage, TextLink, Textarea } from '@contentful/forma-36-react-components';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/**
 * Retreive a Contentful content management SDK space object and environment object
 * @param {string} spaceId ID of the space
 * @param {string} environmentId ID of the environment
 * @param {string} accessToken Personal access token with permissions on the space and environment
 */

function getSpaceEnvironment(_x, _x2, _x3) {
  return _getSpaceEnvironment.apply(this, arguments);
}

function _getSpaceEnvironment() {
  _getSpaceEnvironment = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(spaceId, environmentId, accessToken) {
    var client, space, environment;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            client = createClient({
              accessToken: accessToken
            });
            _context.next = 3;
            return client.getSpace(spaceId);

          case 3:
            space = _context.sent;
            _context.next = 6;
            return space.getEnvironment(environmentId);

          case 6:
            environment = _context.sent;
            return _context.abrupt("return", {
              space: space,
              environment: environment
            });

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getSpaceEnvironment.apply(this, arguments);
}

/**
 * Creates/updates the given of content type.
 *
 * When updating an existing content type, this will maintain any existing fields that do not exist within the passed in contentTypeConfig.
 * This is to allow the content types to be extendable via the Contentful UI.
 *
 * @param {object} environment - The contentful environment to create/update the content type in.
 * @param {object} contentTypes - The content type to create/update.
 */

var createOrUpdateContentType = curry( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(environment, contentTypeConfig) {
    var _yield$environment$ge, contentTypes, contentTypeIds, contentType, configurationFieldIds, existingFieldsToKeep, resultingFields;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return environment.getContentTypes();

          case 2:
            _yield$environment$ge = _context.sent;
            contentTypes = _yield$environment$ge.items;
            contentTypeIds = contentTypes.map(function (contentType) {
              return contentType.sys.id;
            });

            if (!contentTypeIds.includes(contentTypeConfig.contentTypeId)) {
              _context.next = 23;
              break;
            }

            _context.next = 8;
            return environment.getContentType(contentTypeConfig.contentTypeId);

          case 8:
            contentType = _context.sent;
            // must set individual fields when using this wrapper
            contentType.name = contentTypeConfig.name;
            contentType.description = contentTypeConfig.description;
            contentType.displayField = contentTypeConfig.displayField; // if new fields are added in the UI or otherwise, trying to just pass in our standard fields will result in an error
            // because you cannot delete a field without first disabling it.
            // To prevent breaking things that rely on other fields,
            // merge in any existing field that isn't in our standard configuration.

            configurationFieldIds = contentTypeConfig.fields.map(function (field) {
              return field.id;
            });
            existingFieldsToKeep = contentType.fields.filter(function (field) {
              return !configurationFieldIds.includes(field.id);
            });
            resultingFields = [].concat(_toConsumableArray(existingFieldsToKeep), _toConsumableArray(contentTypeConfig.fields));
            contentType.fields = resultingFields;
            _context.next = 18;
            return contentType.update();

          case 18:
            contentType = _context.sent;
            _context.next = 21;
            return contentType.publish();

          case 21:
            _context.next = 28;
            break;

          case 23:
            _context.next = 25;
            return environment.createContentTypeWithId(contentTypeConfig.contentTypeId, omit(["contentTypeId"], contentTypeConfig));

          case 25:
            contentType = _context.sent;
            _context.next = 28;
            return contentType.publish();

          case 28:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}());

/**
 * Creates/updates the given list of content types.
 * @param {object} environment - The contentful environment to create/update the content types in.
 * @param {object[]} contentTypes - The content types to create/update.
 */

var createOrUpdateContentTypes = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(envrionment, contentTypes) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all(contentTypes.map(createOrUpdateContentType(envrionment)));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createOrUpdateContentTypes(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Create or update a webhook within the given space. Uses the provided webhook ID to determine if the webhook already exists.
 * If it does will udpate the existing webhook with any altered properties, otherwise will create a new webhook.
 *
 * When updating an existing webhook, this will maintain any existing properties that do not exist within the passed in webhookConfig.
 * If an already existing property needs to be removed, pass that property with the value 'undefined'.
 *
 * @param {Object} space - Contentful content management SDK space object
 * @param {Object} webhookId - The ID to use when saving the webhook
 * @param {string} webhookConfig - A Contentful standardized webhook config object (https://www.contentful.com/developers/docs/references/content-management-api/#/reference/webhooks)
 */

var createOrUpdateWebhook = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(space, webhookId, webhookConfig) {
    var existingWebhook, errorDetails, newHeaderKeys, oldHeadersToKeep;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return space.getWebhook(webhookId);

          case 3:
            existingWebhook = _context.sent;
            _context.next = 11;
            break;

          case 6:
            _context.prev = 6;
            _context.t0 = _context["catch"](0);
            errorDetails = JSON.parse(_context.t0.message); // Don't throw an error on a 404 as this means the webhook has not been created yet

            if (!(errorDetails.status !== 404)) {
              _context.next = 11;
              break;
            }

            throw _context.t0;

          case 11:
            if (!existingWebhook) {
              _context.next = 19;
              break;
            }

            newHeaderKeys = pluck("key", webhookConfig.headers); // Get list of existing headers that aren't in the new webhookConfig object

            oldHeadersToKeep = reject(function (header) {
              return contains(header.key, newHeaderKeys);
            }, existingWebhook.headers); // Update properties on the existing webhook with values from the provided webhook config

            Object.entries(webhookConfig).forEach(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                  key = _ref3[0],
                  value = _ref3[1];

              if (key === "headers") {
                existingWebhook[key] = [].concat(_toConsumableArray(oldHeadersToKeep), _toConsumableArray(value));
                return;
              }

              existingWebhook[key] = value;
            });
            _context.next = 17;
            return existingWebhook.update();

          case 17:
            _context.next = 22;
            break;

          case 19:
            _context.next = 21;
            return space.createWebhookWithId(webhookId, webhookConfig);

          case 21:
            existingWebhook = _context.sent;

          case 22:
            return _context.abrupt("return", existingWebhook);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 6]]);
  }));

  return function createOrUpdateWebhook(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Creates/updates the given list of webhooks.
 * @param {object} space - Contentful content management SDK space object
 * @param {object[]} webhookConfigs - The webhooks to create/update.
 */

var createOrUpdateWebhooks = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(space, webhookConfigs) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Promise.all(webhookConfigs.map(function (webhookConfig) {
              return createOrUpdateWebhook(space, webhookConfig.webhookId, omit(["webhookId"], webhookConfig));
            }));

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createOrUpdateWebhooks(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Error class for use when prerequisite content types/apps are missing.
 * @extends Error
 */
var PrerequisiteError = /*#__PURE__*/function (_Error) {
  _inherits(PrerequisiteError, _Error);

  var _super = _createSuper(PrerequisiteError);

  function PrerequisiteError(message) {
    var _this;

    _classCallCheck(this, PrerequisiteError);

    _this = _super.call(this, message);
    _this.name = "PrerequisiteError";
    return _this;
  }

  return PrerequisiteError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

/**
 * UI Element to display errors during the onConfiguration step of an Apps installation process.
 */

var InstallationErrors = function InstallationErrors(_ref) {
  var configError = _ref.configError;

  var _React$useState = useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      viewFullError = _React$useState2[0],
      setViewFullError = _React$useState2[1];

  return /*#__PURE__*/createElement(Fragment, null, configError && configError instanceof PrerequisiteError && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(ValidationMessage, null, configError.message)), configError && !(configError instanceof PrerequisiteError) && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(ValidationMessage, null, /*#__PURE__*/createElement(TextLink, {
    linkType: "negative",
    onClick: function onClick() {
      return setViewFullError(!viewFullError);
    }
  }, "Installation eror: click to view the full error details")), viewFullError && /*#__PURE__*/createElement(Textarea, {
    "aria-label": "Error Details",
    value: configError.stack,
    disabled: true,
    error: true,
    rows: 10
  })));
};

InstallationErrors.defaultProps = {
  configError: null
};
InstallationErrors.propTypes = {
  /**
   * The error thrown during the configuration process
   */
  configError: PropTypes.objectOf(PropTypes.any)
};

/**
 * Confirms whether or not the given content types exist within the space.
 * @param {object} environment - The contentful environment to check for the content types.
 * @param {string[]} prereqContentTypes - The content type ids to check for.
 * @throws {PrerequisiteError} - If any content types are missing, throws a PrerequisiteError exception containing the list of missing types.
 */

var validatePrereqContentTypes = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(environment, prereqContentTypes) {
    var _yield$environment$ge, contentTypes, existingContentTypes, missingContentTypes;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return environment.getContentTypes();

          case 2:
            _yield$environment$ge = _context.sent;
            contentTypes = _yield$environment$ge.items;
            existingContentTypes = map(path(["sys", "id"]))(contentTypes);
            missingContentTypes = reject(contains(__, existingContentTypes))(prereqContentTypes);

            if (!(missingContentTypes.length > 0)) {
              _context.next = 8;
              break;
            }

            throw new PrerequisiteError("Missing required content type(s): ".concat(missingContentTypes.join(", ")));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validatePrereqContentTypes(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Confirms whether or not the given apps are installed within the space.
 * @param {object} environment - The contentful environment to check for the apps.
 * @param {string[]} prereqApps - The apps ids to check for.
 * @throws {PrerequisiteError} - If any content types are missing, throws a PrerequisiteError exception containing the list of missing apps.
 */


var validatePrereqApps = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(environment, prereqApps) {
    var _yield$environment$ge2, apps, existingApps, missingApps;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return environment.getAppInstallations();

          case 2:
            _yield$environment$ge2 = _context2.sent;
            apps = _yield$environment$ge2.items;
            existingApps = map(path(["sys", "appDefinition", "sys", "id"]))(apps);
            missingApps = reject(contains(__, existingApps))(prereqApps);

            if (!(missingApps.length > 0)) {
              _context2.next = 8;
              break;
            }

            throw new PrerequisiteError("Missing required app id(s): ".concat(missingApps.join(", ")));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function validatePrereqApps(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

export { InstallationErrors, PrerequisiteError, createOrUpdateContentType, createOrUpdateContentTypes, createOrUpdateWebhook, createOrUpdateWebhooks, getSpaceEnvironment, validatePrereqApps, validatePrereqContentTypes };
